import { Card, CardContent, CardHeader, formatSurveyDate } from "frontend-components";
import { useTranslation } from "react-i18next";
import StatusBadge from "./StatusBadge";
import SurveyLink from "./SurveyLink";
import type { SurveyTableRow } from "./types";

type SurveyTableCardProps = {
    survey: SurveyTableRow;
    customerId: string;
};

export default function SurveyTableCard({ survey, customerId }: SurveyTableCardProps) {
    const { t, i18n } = useTranslation();
    const createdBy = survey.createdBy
        ? `${survey.createdBy.firstName} ${survey.createdBy.lastName}`
        : t("common.unknown");

    return (
        <li>
            <Card size="sm" className="border-compendia-border border shadow-sm">
                <CardHeader className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-3">
                    <SurveyLink
                        survey={survey}
                        customerId={customerId}
                        className="line-clamp-2 min-w-0 wrap-break-word text-base font-medium"
                    />
                    <StatusBadge status={survey.status} />
                </CardHeader>

                <CardContent>
                    <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-label">
                        <div className="min-w-0">
                            <dt className="text-compendia-muted">{t("survey.responses")}</dt>
                            <dd className="text-compendia-foreground">
                                {survey.participantCount.answered} / {survey.participantCount.total}
                            </dd>
                        </div>
                        <div className="min-w-0">
                            <dt className="text-compendia-muted">{t("common.created")}</dt>
                            <dd className="text-compendia-foreground">
                                {formatSurveyDate(survey.createdAt, i18n.language)}
                            </dd>
                        </div>
                        <div className="min-w-0">
                            <dt className="text-compendia-muted">{t("common.createdBy")}</dt>
                            <dd className="wrap-break-word text-compendia-foreground">
                                {createdBy}
                            </dd>
                        </div>
                        <div className="min-w-0">
                            <dt className="text-compendia-muted">
                                {t("survey.reminderSentTitle")}
                            </dt>
                            <dd className="text-compendia-foreground">
                                {survey.reminderSentAt
                                    ? formatSurveyDate(survey.reminderSentAt, i18n.language)
                                    : "–"}
                            </dd>
                        </div>
                    </dl>
                </CardContent>
            </Card>
        </li>
    );
}
